<template>
  <div>
    <data-manage-page 
      ref="baseTable"
      :store-namespace="storeNamespace" 
      :tag-index="tagIndex" 
      :columns="columns"
      :fields="fields"
      :page="pagination"
      @update:selection="handleSelectionChange"
      @update:pagination="handlePaginationChange"
    >
      <!-- Custom action button -->
      <template #actions>
      </template>

      <!-- Custom filters -->
      <template #filters>
      </template>

      <!-- #region
        Custom render table 
      -->
      <a slot="uid" slot-scope="{ text }" :href="('https://x.com/' + text)" target="_blank">
        {{ text }}
      </a>

      <template slot="tfa" slot-scope="{ text }">
        <a-icon v-if="!!text" type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
      </template>

      <span slot="email" slot-scope="{ text }">{{ maskedEmail(text) }}</span>

      <template slot="tag_ids" slot-scope="{ record }">
        <template v-for="tag_id in record.tag_ids">
          <a-tag :key="tag_id" closable @close="handleUnassignTag(record.id, tag_id)"
            v-if="tagExisted(tag_id)">{{ getTagTitleById(tag_id) }}</a-tag>
        </template>
      </template>

      <template slot="operation" slot-scope="{ record }">
        <a href="javascript:;" v-if="!!record.has_ads" @click="showAds(record.fb_id)"><a-icon type="eye" /> ADS</a>
      </template>

      <a-badge v-if="text != null || text != undefined" :overflowCount="5001" slot="total_friends" slot-scope="{ text }"
        show-zero :count="text" :number-style="{ backgroundColor: '#999' }" 
      />

      <a-badge v-if="!!text" :overflowCount="3000" slot="birthday" slot-scope="{ text }" show-zero
        :count="new Date(text).getFullYear()" :number-style="{ backgroundColor: '#999' }" 
      />

      <span v-if="!!text" slot="registration_time" slot-scope="{ text }">
        {{ new Date(text).toLocaleString() }}
      </span>
      <!-- #endregion -->
       
    </data-manage-page>
  </div>
</template>

<style></style>

<script>
import DataManagePage from '../data-layout/DataManagePage.vue';
import { mapActions, mapGetters } from 'vuex';

const fields = [
  { title: 'UID', key: 'uid' },
  { title: 'Password', key: 'password' },
  { title: '2FA', key: 'tfa' },
  { title: 'Mail', key: 'email' },
  { title: 'Cookie', key: 'cookie' },
  { title: 'Name', key: 'name' },
  { title: 'Registration time', key: 'registration_time' },
  { title: 'Note', key: 'note' },
  { title: 'Language', key: 'lang' },
  { title: 'Useragent', key: 'useragent' },
];

const columns = [
  {
    title: 'UID',
    dataIndex: 'uid',
    key: 'uid',
    width: '180px',
    fixed: 'left',
    scopedSlots: { customRender: 'uid' }
  },
  {
    title: '2FA',
    dataIndex: 'tfa',
    key: 'tfa',
    width: '60px',
    align: 'center',
    scopedSlots: { customRender: 'tfa' }
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    scopedSlots: { customRender: 'email' }
  },
  {
    title: 'Tags',
    dataIndex: 'tag_ids',
    key: 'tag_ids',
    scopedSlots: { customRender: 'tag_ids' }
  },
  {
    title: 'Tên',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'Thời gian tạo',
    dataIndex: 'registration_time',
    key: 'registration_time',
    scopedSlots: { customRender: 'registration_time' }
  },
  {
    title: 'Note',
    dataIndex: 'note',
    key: 'note',
    fixed: 'right',
    width: '400px',
  },
  {
    title: 'Thao tác',
    fixed: 'right',
    width: '150px',
    scopedSlots: { customRender: 'operation' },
  }
];

export default {
  name: 'FbAccount',
  components: {
    DataManagePage,
  },
  data() {
    return {
      app: this.$root.$children[0],
      columns,
      fields,
      filter: {},

      tagIndex: 'fb-account',
      storeNamespace: 'facebookAccount',

      selectedData: [],
      selectedDataIds: [],
      selectedDataUids: [],

      pagination: {
        total: 0,
        pageSize: 10,
        current: 1,
        showSizeChanger: true,
        pageSizeOptions: ['10', '30', '50', '100', '200', '500', '1000'],
      },
    };
  },

  watch: {
    filter: {
      deep: true,
      handler() {
        this.buildFilter();
      },
    },
  },

  computed: {
    ...mapGetters('tag', {
      tags: 'getTags'
    }),

    ...mapGetters('job', {
      jobs: "getJobs"
    }),
  },

  methods: {
    ...mapActions("facebookAccount", {
      unassignTag: "unassignTag",
    }),

    ...mapActions("tag", {
      fetchTags: "fetchTags",
      addTag: "addTag",
      assignTag: "assignTag",
      deleteTag: "deleteTag"
    }),

    handleSelectionChange(selection) {
      this.selectedDataIds = selection.selectedDataIds;
      this.selectedDataUids = selection.selectedDataUids;
      this.selectedData = selection.selectedData;
    },

    handlePaginationChange(pagination) {
      this.pagination.total = pagination.total;
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
    },
    
    buildFilter() {
      const filter = {};

      return filter;
    },

    maskedEmail(email) {
      if (!email) return '';
      const [name, domain] = email.split('@');
      if (!name || !domain) return email;
      
      const maskedName = name[0] + '*'.repeat(Math.max(name.length - 1, 1));
      
      return `${maskedName}@${domain}`;
    },

    getTagTitleById(tagId) {
      const tag = this.tagExisted(tagId);

      if (!tag) {
        return null;
      }

      return tag.title;
    },

    tagExisted(tagId) {
      if (tagId && this.tags.length > 0) {
        const tag = this.tags.find(tag => tag.id == tagId);

        if (tag) {
          return tag;
        }
      }

      return false;
    },

    async handleUnassignTag(id, tag_id) {
      this.app.callApi(async () => {
        await this.unassignTag({id, tag_id});
        this.$message.success('Gỡ tag thành công!');
      });
    },
  },
};
</script>